module.exports = __webpack_public_path__ + "img/hzm-back.62a9d846.png";